import { useState } from "react";
import { CalendarDays, Radio } from "lucide-react";
import type { ViewMode } from "./types";
import PlanList from "@/views/PlanList";
import DispatchToday from "@/views/DispatchToday";

export default function App() {
  const [mode, setMode] = useState<ViewMode>("plan");

  return (
    <div className="min-h-full flex flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-xl font-bold tracking-tight">FFT Schedule Builder</span>
            <span className="text-xs text-slate-400 font-medium">rebuild</span>
          </div>
          <nav className="flex items-center gap-1 rounded-lg bg-slate-100 p-1">
            <TabButton active={mode === "plan"} onClick={() => setMode("plan")} icon={<CalendarDays size={16} />}>
              Plan
            </TabButton>
            <TabButton active={mode === "dispatch"} onClick={() => setMode("dispatch")} icon={<Radio size={16} />}>
              Dispatch
            </TabButton>
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6">
        {mode === "plan" ? <PlanList /> : <DispatchToday />}
      </main>
    </div>
  );
}

function TabButton({
  active,
  onClick,
  icon,
  children,
}: {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={
        "flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition " +
        (active ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700")
      }
    >
      {icon}
      {children}
    </button>
  );
}
